export const removecartitem = async (customer_id, item_id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/add-cart/?customer_id=${customer_id}&item_id=${item_id}`,
      {
        method: "DELETE",
      }
    );

    if (!response.ok) {
      throw new Error("Failed to remove item from cart");
    }

    return await response.json();
  } catch (error) {
    throw new Error(`API Error: ${error.message}`);
  }
};
